var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex justify-content-center p-4"},[_c('card',{staticClass:"col-md-4"},[_c('h3',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Cadastro")]),_c('form',{attrs:{"action":"#"}})])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }